import { useSelector } from 'react-redux';
import { TFilterKeys } from '../../../types/filters';
import { useMemo } from 'react';
import { selectOpenedFilter, selectTooltipTarget } from '../../../selectors/filters';
import { useTooltipDisabled } from './useTooltipDisabled';

interface IUserMetaTooltipProps {
  filterKey: TFilterKeys;
}

export const useMetaTooltip = ({ filterKey }: IUserMetaTooltipProps) => {
  const isTooltipDisabled = useTooltipDisabled();
  const tooltipTarget = useSelector(selectTooltipTarget);
  const openedFilter = useSelector(selectOpenedFilter);

  return useMemo(
    () => !isTooltipDisabled && tooltipTarget === filterKey && (!openedFilter || openedFilter === filterKey),
    [filterKey, isTooltipDisabled, tooltipTarget, openedFilter],
  );
};
